import { MAIN_STORAGES, STORAGE_USER_PREF } from "../constants/localstorage";
import { delStorage, getStorage, hasStorage, setStorage, storagePrefix } from "./storage";

function logMigrate(...args: Array<any>) {
  // console.log("#migrate__ ", ...args);
}

export class MigrateStorage {
  constructor() {
    this.checkUserPref();
  }

  checkUserPref() {
    const userPref = window.localStorage.getItem(storagePrefix + STORAGE_USER_PREF);
    if (!userPref) {
      logMigrate("userPref not founded , migrating✈️...");
      this.initUserPref();
    }
    this.checkStorageWithUserPref();
  }

  checkStorageWithUserPref() {
    const storagesInPref = !MAIN_STORAGES.map((storageKey) => hasStorage(storageKey)).includes(false);

    if (storagesInPref) {
      logMigrate("everything is ok , no need to migrate ✅");
      this.afterCheck();
    } else {
      this.checkAnotherPrefixStorage();
    }
  }

  checkAnotherPrefixStorage() {
    const currentPrefix = ["", `1__`, `2__`, `3__`].find(
      (pref) =>
        !MAIN_STORAGES.map((storageKey) => {
          console.log("checking for ", storagePrefix + pref + storageKey);
          return !!window.localStorage.getItem(storagePrefix + pref + storageKey);
        }).includes(false)
    ) as string;
    logMigrate("prefix is ", currentPrefix);
    if (currentPrefix === "" || !currentPrefix) this.initUserPref();
    else setStorage(STORAGE_USER_PREF, currentPrefix[0], undefined, false);
    this.migrateToMultiAccount();
  }

  initUserPref() {
    setStorage(STORAGE_USER_PREF, "1", undefined, false);
  }

  migrateToMultiAccount() {
    MAIN_STORAGES.forEach((storageKey) => {
      setStorage(storageKey, getStorage(storageKey, false));
      delStorage(storageKey, false);
    });
    this.afterCheck();
  }

  afterCheck() {
    logMigrate("MigrateCompleted ");
    console.group("final : ");
    MAIN_STORAGES.forEach((storage) => {
      logMigrate(`key{${storage}} : `, getStorage(storage));
    });
    console.groupEnd();
  }
}
